var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_vm._t("default",function(){return [_c('i',{staticClass:"loading-1"}),_c('i',{staticClass:"loading-2"}),_c('i',{staticClass:"loading-3"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }